'use strict';

// Mobile apps controller
angular.module('mobile-apps').controller('TagsListController', [
	'$scope',
	'$rootScope',
	'$stateParams',
	'$location',
	'MobileApps',
	'TagMain',
	'Utilities',
	'SweetAlert',
	'$timeout',
	'DEFAULT_TAG_CATEGORIES',
	function (
		$scope,
		$rootScope,
		$stateParams,
		$location,
		MobileApps,
		TagMain,
		Utilities,
		SweetAlert,
		$timeout,
		DEFAULT_TAG_CATEGORIES
	) {
		$scope.mobileAppId = $stateParams.mobileAppId;
		$scope.TagMain = TagMain;
		$scope.displayTags = [];

		$scope.tagCategories = angular.copy(DEFAULT_TAG_CATEGORIES);
		TagMain.loadTagCategories($stateParams.mobileAppId, true, function (err, result) {
			if (!jQuery.isEmptyObject(TagMain.tagCategories)) {
				Object.keys(TagMain.tagCategories).forEach(function (tagCategory) {
					if (!$scope.tagCategories.some(function (item) { return item.name === tagCategory.name; })) {
						$scope.tagCategories.push(TagMain.tagCategories[tagCategory]);
					}
				});
			}
		});


		/**
		 * Initializes the list view
		 */
		$scope.initListView = function() {
			$scope.mobileApp = MobileApps.get({
				mobileAppId: $stateParams.mobileAppId
			}, function(mobileApp) {});

			$scope.initTags(true);

			TagMain.adjustSidebarWidth();
		};


		$scope.$on('$destroy', function() {
			// Change the size of the sidebar when the Tag-List gets closed
			TagMain.adjustSidebarWidth();
		});


		/**
		 * Initializes the tags
		 */
		$scope.initTags = function(forceRefresh) {
			TagMain.loadTags($stateParams.mobileAppId, forceRefresh, function(err, result) {
				if (err) {
					Utilities.showMessage('Problem Loading Tags', 'We had a problem loading the tags. Please try again or contact our support.', 'error');
					return;
				}

				$scope.displayTags.length = 0;
				TagMain.tagIdsArray.forEach(function(tagId) {
					$scope.displayTags.push(TagMain.tags[tagId]);
				});

				$scope.loadedStatus = true;
			});

		};



		/**
		 * Returns the tool tip text for the given entry-ids
	     */
		$scope.getEntryIdToolTip = function(entryIds) {
			var maxEntries = 10;
			if (entryIds.length === 0) {
				return 'Tag does have not have any entries.';
			} else {
				if (entryIds.length > maxEntries) {
					return 'Entry Ids: ' + entryIds.slice(0, maxEntries).join(', ') + ' and ' + (entryIds.length - maxEntries)  + ' more';
				}
				return 'Entry Ids: ' + entryIds.join(', ');
			}
		};


		/**
		 * Gets called when the live-edt-field change the name of a tag
		 * @param name The new name of the tag
		 * @param tagId The id of the tag to change
		 */
		$scope.tagChangeCallback = function(name, tagId, categoryName) {

			TagMain.updateTag(tagId, name, categoryName, function (err) {
				if (err) {
					var errorMessage = 'There was a problem updating the tag';
					if (err.data.message.code === 11000) {
						errorMessage =  'A tag with that name already exists.';
					} else if (err.status === 400) {
						errorMessage =  err.data.message;
					}

					Utilities.showMessage('Problem changing tag', errorMessage, 'error');
				}
			});
		};


		/**
		 * Changes the location of the given tag in the list
		 */
		$scope.moveTag = function($event, tag, direction) {
			$event.preventDefault();
			$event.stopPropagation();

			TagMain.moveTag(tag, direction, function(err, tag) {
				if (err) {
					Utilities.showMessage('Problem moving tag', 'There was a problem moving the tag. Please try again or contact our support. Thanks!', 'error');
				}
			});
		};


		$scope.openCreateTagModal = function () {
			SweetAlert.swal(
				{
					title             : 'Create Tag',
					text              : 'Name of new tag:',
					type              : 'input',
					input             : 'text',
					showCancelButton  : true,
					confirmButtonColor: '#DD6B55',
					confirmButtonText : 'Create',
					cancelButtonText  : 'Cancel!',
					closeOnConfirm    : true,
					closeOnCancel     : true
				},
				function (tagName) {
					if (tagName) {
						TagMain.createTag({name: tagName}, function (err) {
							if (err) {
								var errorMessage = 'There was a problem creating the tag';
								if (err.status === 400) {
									errorMessage =  err.data.message;
								}
								$timeout(function() {
									SweetAlert.swal(
										{
											title: 'oops!',
											text: errorMessage,
											type: 'warning',
											showCancelButton: false
										}
									);
								}, 150);

								return;
							}

						});
					}
				}
			);
		};


		/**
		 * Activates the tag edit mode for the given tag
		 */
		$scope.startEditTag = function (tag, $event) {
			$event.stopPropagation();

			$rootScope.$broadcast('liveEditFieldActiveChanged', {
				key: tag._id,
				language: 'none'
			});
		};


		$scope.openDeleteTagModal = function (tag, $event) {
			// Do not go to the screenshot page
			// (which it would normally do because of ui-sref)
			$event.stopPropagation();

			SweetAlert.swal(
				{
					title             : 'Are you sure?',
					text              : 'This will delete the Tag "' + tag.name + '" forever and can not be recovered.',
					type              : 'warning',
					showCancelButton  : true,
					confirmButtonColor: '#DD6B55',
					confirmButtonText : 'Yes, delete it!',
					cancelButtonText  : 'No, cancel!',
					closeOnConfirm    : true,
					closeOnCancel     : true
				},
				function (isConfirm) {
					if (isConfirm) {
						TagMain.removeTag(tag._id, function (err) {
							if (err) {

								var errorMessage = 'There was a problem deleting the tag';
								if (err.status === 400) {
									errorMessage =  err.data.message;
								}
								$timeout(function() {
									SweetAlert.swal(
										{
											title: 'oops!',
											html: true,
											text: '<div style="max-height: 300px;overflow: auto;">' + errorMessage + '</div>',
											type: 'warning',
											showCancelButton: false
										}
									);
								}, 150);

								return;
							}

						});
					}
				}
			);
		};

		$scope.getTagCategoryColor = function(categoryName){
			if($scope.tagCategories && categoryName){
				var category = $scope.tagCategories.find(function(item){ return item.name.toLowerCase() === categoryName.toLowerCase(); });
				if(category){
					return category.color;
				}
			}
			return;
		};

		$scope.tagCategoryFilterValue = 'All';
		$scope.filterTagList = function(categoryName){

			$scope.displayTagsFiltered = [];

			if(categoryName){
				var category = $scope.tagCategories.find(function(item){ return item.name.toLowerCase() === categoryName.toLowerCase(); });
				if(category){
					$scope.tagCategoryFilterValue = category.name;
				}
			} else {
				$scope.tagCategoryFilterValue = 'All';
			}
			
			TagMain.tagIdsArray.forEach(function(tagId) {
				if(!categoryName || TagMain.tags[tagId].category === categoryName){
					$scope.displayTagsFiltered.push(TagMain.tags[tagId]);
				}
			});

			$scope.displayTags = $scope.displayTagsFiltered;
		};

		// Whenever a language entry got deleted or updated we update the tags
		$scope.$on('tagsChanged', function () {
			// Load all tags new and force refresh
			$scope.initTags(true);
			$scope.tagCategoryFilterValue = 'All';
		});
		$scope.$on('entriesChanged', function () {
			// Load all tags new and force refresh
			$scope.initTags(true);
		});
	}
]);
